import { apiFetch } from './client';

const BASE = '/products';

/** List products (paged). @param {{page?:number,size?:number,sort?:string,signal?:AbortSignal}} [opts] */
export const list = ({ page = 0, size = 20, sort = 'name,asc', signal } = {}) =>
  apiFetch(`${BASE}?page=${page}&size=${size}&sort=${sort}`, { signal });

/** Get a product by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/** Create a product. */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update a product. */
export const update = (id, body, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete a product. */
export const remove = (id, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'DELETE', signal });

/** List a product's owners (customers), paged. */
export const listOwners = (id, { page = 0, size = 20, signal } = {}) =>
  apiFetch(`${BASE}/${id}/customers?page=${page}&size=${size}`, { signal });
